var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdnoddMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#335aa8;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke-width:0px;}.cls-2{fill:#4c3994;}.cls-3{fill:#be2433;}.cls-4{fill:#7b3593;}.cls-5{fill:#c85d29;}.cls-6{fill:#0c9787;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M960,169.91c-199.43,0-361.09,161.67-361.09,361.09s161.67,361.09,361.09,361.09,361.09-161.67,361.09-361.09-161.67-361.09-361.09-361.09ZM960.49,870.69c-187.6,0-339.69-152.08-339.69-339.69s152.08-339.69,339.69-339.69,339.69,152.08,339.69,339.69-152.08,339.69-339.69,339.69Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 915.5,
    y: 249,
    width: 89,
    height: 193,
    rx: 21.83,
    ry: 21.83
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 755.1,
    y: 342.18,
    width: 89,
    height: 193,
    rx: 21.83,
    ry: 21.83,
    transform: "translate(19.89 911.82) rotate(-60)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 755.6,
    y: 527.68,
    width: 89,
    height: 193,
    rx: 21.83,
    ry: 21.83,
    transform: "translate(659.6 1629.18) rotate(-120)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 916.5,
    y: 620,
    width: 89,
    height: 193,
    rx: 21.83,
    ry: 21.83,
    transform: "translate(1922 1433) rotate(-180)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1076.9,
    y: 526.82,
    width: 89,
    height: 193,
    rx: 21.83,
    ry: 21.83,
    transform: "translate(2221.9 -36.18) rotate(120)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1076.4,
    y: 341.32,
    width: 89,
    height: 193,
    rx: 21.83,
    ry: 21.83,
    transform: "translate(939.61 -751.82) rotate(60)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdnoddMobile);
export default __webpack_public_path__ + "static/media/adnodd-mobile.a590f562bf9faf068c595147695f7493.svg";
export { ForwardRef as ReactComponent };